
export function deepCopy(source: any, shallowCopyFields: Array<string> = [], path = '') {
  if (!source || typeof source !== 'object'){
    throw new Error('error arguments')
  }

  let result: Record<string, any> = Array.isArray(source) ? [] : {}
  for (let key in source) {
    if (source.hasOwnProperty(key)) {
      const fullPath = `${path}${path ? '.' : ''}${key}`

      if (
        source[key] && typeof source[key] === 'object'
        && !shallowCopyFields.includes(fullPath))
      {
        result[key] = deepCopy(source[key], shallowCopyFields, fullPath)
      } else {
        result[key] = source[key]
      }
     } 
  }

  return result
}